import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import helpers from "../../lib/helpers";
import HouseIcon from "!!raw-loader!../../assets/icons/place-of-home.svg";
import CenterIcon from "!!raw-loader!../../assets/icons/center.svg";

export default function StopListItem({
  title,
  index,
  highlight,
  duration,
  calculatedPeriod,
  type,
  locationType,
  backgroundColor,
}) {
  const router = useRouter();
  const { query } = router;
  const liElementRef = useRef();
  const [selected, setSelected] = useState(false);

  const getHeight = () => {
    const d = calculatedPeriod ? calculatedPeriod.duration : duration;

    if (d.inDays === 1) return "2.5rem";
    // from 26 days it's "xy month(s)"
    if (d.inDays < 26) return "5rem";
    // from 11 months it's "xy year(s)"
    if (d.inMonths < 11) return "10rem";
    else return "20rem";
  };

  useEffect(() => {
    if (!liElementRef.current || !query.stop) return;

    const selectedStop = parseInt(query.stop);

    if (selectedStop === index) {
      setSelected(true);
      if (!helpers.isElementInViewport(liElementRef.current)) {
        liElementRef.current.scrollIntoView();
      }
    } else {
      setSelected(false);
    }
  }, [query.stop]);

  return (
    <li
      id={index}
      ref={liElementRef}
      className={`px-2 xl:px-3 py-1 xl:py-2 flex mb-1 cursor-pointer transition duration-200 bg-beta ${
        selected ? "selected" : ""
      } `}
      style={{ background: highlight ? backgroundColor : null, height: getHeight() }}
    >
      <Link
        href={{ pathname: router.pathname, query: { ...query, stop: index, time: null } }}
        shallow
        replace
      >
        <a className="flex items-center w-full h-full text-black">
          <div className="w-3/4 flex-grow flex flex-col">
            <span
              className="text-xs xl:text-sm uppercase"
              style={{ lineHeight: "0.8rem" }}
            >
              {title}
            </span>
            {duration.inDays >= 26 && (
              <span className="text-extraTiny" style={{ lineHeight: "0.8rem" }}>
                {duration.string}
              </span>
            )}
          </div>
          {locationType === "center" ? (
            <div
              dangerouslySetInnerHTML={{ __html: CenterIcon }}
              className="center-icon w-2 xl:w-4 ml-1 xl:ml-3 inline-block flex-shrink-0"
            ></div>
          ) : null}
          {type === "place_of_home" ? (
            <div
              dangerouslySetInnerHTML={{ __html: HouseIcon }}
              className="house-icon w-2 xl:w-4 ml-3 inline-block flex-shrink-0"
            ></div>
          ) : null}
        </a>
      </Link>
    </li>
  );
}
